import * as Dialog from "@radix-ui/react-dialog";
import { useTranslation } from "react-i18next";

import styles from "./AlertsLaunchDialog.module.css";

import illustration from "@/assets/images/alerts-launch-macbook.png";
import { ButtonV2 } from "@/components/atoms/Button";
import { ChipV2 } from "@/components/atoms/Chip";
import { IconButtonV2 } from "@/components/atoms/IconButton";

interface Props {
  open: boolean;
  onActivate: () => void;
  onDismiss: () => void;
}

export const AlertsLaunchDialog = ({ open, onActivate, onDismiss }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next) onDismiss();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.dialog}>
          <div className={styles.media}>
            <img className={styles.illustration} src={illustration} alt="" />
          </div>
          <div className={styles.panel}>
            <div className={styles.close}>
              <IconButtonV2
                icon="close"
                size="sm"
                aria-label={t("alerts.launchDialog.close")}
                onClick={onDismiss}
              />
            </div>
            <div className={styles.content}>
              <ChipV2 variant="accent" label={t("alerts.launchDialog.label")} />
              <div className={styles.text}>
                <Dialog.Title className={styles.title}>
                  {t("alerts.launchDialog.title")}
                </Dialog.Title>
                <Dialog.Description className={styles.description}>
                  {t("alerts.launchDialog.description")}
                </Dialog.Description>
              </div>
            </div>
            <div className={styles.actions}>
              <ButtonV2 endIcon="arrowForward" onClick={onActivate}>
                {t("alerts.launchDialog.activate")}
              </ButtonV2>
              <ButtonV2 variant="secondary" onClick={onDismiss}>
                {t("alerts.launchDialog.dismiss")}
              </ButtonV2>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
